import { Button } from "@material-tailwind/react"
import { createPortal } from "react-dom"

interface Option {
    value: string
    label: string
    color: string
}

interface ConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  selectedOption: Option | null
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, onClose, selectedOption }) => {
  if (!isOpen) return null

  return (
    createPortal(
        
        <div className="fixed top-0 left-0 w-full h-full z-50">
            <div className="absolute inset-0 bg-[#000000] opacity-50"></div>
            <div className="fixed inset-0 flex items-center justify-center z-[101]">
                <div className="bg-white rounded-[25px] shadow-lg w-[448px] h-[212px]">
                    <div className="flex items-center justify-center h-[180px] px-6 text-center">
                        <p className="text-[#2D3748] text-md font-normal leading-6">
                        ¿Seguro que quieres cambiar el estado a{" "}
                        <div className="font-semibold">"{selectedOption?.label}"<span className="text-[#2D3748] text-md font-medium leading-6">?</span></div>
                        </p>
                    </div>
                    <div className="flex grid grid-cols-2 gap-3 -mt-[35px] h-[40px] w-auto">
                        <Button onClick={onClose} aria-label="salir sin guardar" className="bg-[#EDF2F7] text-[#1A202C] text-md font-semibold rounded-[28px] ml-6 shadow-none normal-case">
                            Cancelar
                        </Button>
                        <Button  aria-label="guardar y salir" className="bg-[#390094] text-white text-lg font-semibold rounded-[28px] mr-6 shadow-none normal-case">
                            Cambiar estado
                        </Button>
                    </div>
                </div>
            </div>
        </div>,
     document.body)
  )
}

export default ConfirmationModal